import { Button, List, ListItem } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { getCurrentUserRole } from 'utils/userUtils'

type NavElement = {
  label: string
  path: string
  block?: string[]
}

interface Props {
  elements: NavElement[]
  company: string
}

const ListNavigation = ({ elements, company }: Props) => {
  const navigate = useNavigate()
  const role = getCurrentUserRole()
  const visibleElements = (elements || []).filter(item => {
    if (!item.block || item.block.length === 0) return true
    if (!role) return true
    return !item.block.includes(role)
  })
  return (
    <List
      sx={{
        '& .MuiListItemButton-root': {
          color: '#607998',
          fontFamily: 'sans-serif',
          fontWeight: 600
        },
        '& a': {
          textDecoration: 'none'
        }
      }}
    >
      {visibleElements.map(item => (
        <ListItem key={item.label} sx={{ padding: '40px 20px' }}>
          <Button
            variant='contained'
            onClick={() => {
              navigate(`/${company}${item.path}`)
            }}
            sx={{
              width: '100%',
              textAlign: 'center',
              textTransform: 'none',
              fontSize: '26px',
              padding: '50px 20px',
              backgroundColor: '#364c63'
            }}
          >
            {item.label}
          </Button>
        </ListItem>
      ))}
    </List>
  )
}

export default ListNavigation
